import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, UrlSerializer } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-shopping-stepper',
  templateUrl: './shopping-stepper.component.html',
  styleUrls: ['./shopping-stepper.component.scss'],
})

export class ShoppingStepperComponent implements OnInit, OnDestroy {
    public showstepper = false;
    public selectedIndex = 0;
    private routingHistory = [];
    private routerSubscription: Subscription;
    private readonly serializer: UrlSerializer;

    public constructor(private router: Router, serializer: UrlSerializer) {
        this.serializer = serializer;
    }

    public ngOnInit(): void {
        this.routerSubscription = this.router.events.pipe(
            filter((event: any) => event instanceof NavigationStart))
            .subscribe((event => {
                if (event.url === '/betaling/betalingsmetode' || event.url === '/betaling') {
                    this.showstepper = true;
                    this.setSelectedIndex(0);
                }
                else if (event.url.includes('/betaling/bekraeftelse')) {
                    this.showstepper = true;
                    this.setSelectedIndex(1);
                }
                else if (event.url === '/betaling/dit-spil') {
                    this.showstepper = true;
                    this.setSelectedIndex(1);
                }
                else if (event.url === '/betaling/betaling') {
                    this.showstepper = true;
                    this.setSelectedIndex(2);
                }
                else if (event.url === '/betaling/kvittering') {
                    this.showstepper = true;
                    this.setSelectedIndex(3);
                }
                else {
                    this.showstepper = false;
                }
                // add to routing history in order to search for last place visited in shop
                this.routingHistory = [...this.routingHistory, event.url];
            }));
    }

    public ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    public setSelectedIndex(index: number): void {
        this.selectedIndex = index;
    }

    public move(index: number): void {
        this.selectedIndex = index;
        if (this.selectedIndex === 0) {
            this.router.navigate(['./betaling/betalingsmetode']);
        }
        else if (this.selectedIndex === 1) {
            this.router.navigate(['./betaling/dit-spil']);
        }
        else if (this.selectedIndex === 3) {
            this.router.navigate(['./betaling/kvittering']);
        }
    }

    public returnLastShopRoute(): void {
        if (this.routingHistory.length <= 1) {
            this.router.navigate(['/lodder-til-salg']);
            return;
        }

        for (let i = this.routingHistory.length - 1; i >= 0; i--) {
            const url = this.routingHistory[i];

            if (url.includes('/lodder-til-salg')) {
                if (url.includes('/lodder-til-salg/oenskelodder')) {
                    this.router.navigate(['/lodder-til-salg/oenskelodder']);
                    return;
                }
              }
            }
    }
}
